export const APIURL = '//api.keyders.com';
export const QUERYINFO = 'QUERYINFO';
export const QUERYINFO_ERROR = 'QUERYINFO_ERROR';
export const QUERYINFO_ISLOADING = 'QUERYINFO_ISLOADING';
export const MENUSETTING ='MENUSETTING';
export const BGSETTING = 'BGSETTING';
import moment from 'moment';
import localforage from 'localforage';

export function fetch_setQueryInfo(chipsData, cateChipsData, skills, jobs, fansMin, fansMax, dayQuery, period, sex, sourceOption, sourceValue, kol_name, cat_op){
  const queryInfo = {
    chipsData: chipsData === undefined ? []: chipsData,
    cateChipsData: cateChipsData === undefined ? []: cateChipsData,
    skills: skills === undefined ? []: skills,
    jobs: jobs === undefined ? []: jobs,
    fansMin: fansMin === undefined ? 0.1 : fansMin,
    fansMax: fansMax === undefined ? 3000 : fansMax,
    dayQuery: dayQuery === undefined ? 30 : dayQuery,
    period: period === undefined ? 1 : period,
    sex: sex === undefined ? [0,1,2] : sex,
    sourceOption: sourceOption === undefined ? {fbClass:'FB', ytClass:'YT', igClass:'IG'} : sourceOption,
    sourceValue: sourceValue === undefined ? 'FB,YT,IG' : sourceValue,
    kol_name: kol_name === undefined ? '' : kol_name,
    cat_op: cat_op === undefined ? 'or' : cat_op,
  }

  return (dispatch) =>{
    dispatch(queryInfo_isloading(true))
    localforage.setItem('dashQueryValue',queryInfo).then(function(value) {
        dispatch(queryInfo_success(value))
        dispatch(queryInfo_isloading(false))
    }).catch(function(err) {
        console.log(err)
        dispatch(queryInfo_isloading(false))
        return dispatch(queryInfo_error(true))
    })
  }

}

export function fetch_getQueryInfo(){
  return (dispatch) =>{
    dispatch(queryInfo_isloading(true))
    localforage.getItem('dashQueryValue').then(function(value) {
        if(value){
          dispatch(queryInfo_success(value))
        }
        dispatch(queryInfo_isloading(false))
    }).catch(function(err) {
        console.log(err)
        dispatch(queryInfo_isloading(false))
        return dispatch(queryInfo_error(true))
    })
  }
}

export function queryInfo_isloading(bool){
  return {
    type:QUERYINFO_ISLOADING,
    isLoading: bool
  }
}

export function queryInfo_success(response){
  return {
    type:QUERYINFO,
    payload: response
  }
}

export function queryInfo_error(bool){
  return {
    type:QUERYINFO_ERROR,
    hasErrored:bool,
  }
}

export function menuSetting(q){
  const bool = q===undefined || !q.length>0 ? true: false; 
  return {
    type:MENUSETTING,
    payload: bool
  }
}

export function bgSetting(bgvalue) {
  return {
    type: BGSETTING,
    payload: bgvalue
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js